// // src/pages/auth/SignupStep3Form.jsx
// import React, { useState } from "react";
// import { Box, Button, Grid, TextField, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AuthLayout from "../../components/AuthLayout";

// export default function SignupStep3Form() {
//   const [form, setForm] = useState({
//     name: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // TODO: handle registration logic
//     navigate("/dashboard");
//   };

//   return (
//     <AuthLayout>
//       <Box
//         component="form"
//         onSubmit={handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <Typography variant="h5" textAlign="center" fontWeight={600}>
//           Create your account
//         </Typography>
//         <Typography variant="body2" textAlign="center">
//           Fill in your details to complete registration.
//         </Typography>
//         <Grid item xs={12} sm = {12} lg = {12}>
//             <TextField
//               name="name"
//               label="Full Name"
//               value={form.name}
//               onChange={handleChange}
//               required
//               fullWidth
//             />
//         </Grid>
        

//         <Grid container spacing={2}>
          
//           <Grid item xs={12} sm={6}>
//             <TextField
//               name="phone"
//               label="Phone Number"
//               type="tel"
//               value={form.phone}
//               onChange={handleChange}
//               required
//               fullWidth
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               name="username"
//               label="Username"
//               value={form.username}
//               onChange={handleChange}
//               required
//               fullWidth
//             />
//           </Grid>
//         </Grid>
        
//         <Grid item xs={12} sm={6}>
//             <TextField
//               name="address"
//               label="Address"
//               value={form.address}
//               onChange={handleChange}
//               required
//               fullWidth
//             />
//         </Grid>

//         <Grid container spacing={2}>
          
//           <Grid item xs={12}>
//             <TextField
//               name="password"
//               label="Password"
//               type="password"
//               value={form.password}
//               onChange={handleChange}
//               required
//               fullWidth
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               name="confirmPassword"
//               label="Confirm Password"
//               type="password"
//               value={form.confirmPassword}
//               onChange={handleChange}
//               required
//               fullWidth
//             />
//           </Grid>
//         </Grid>

//         <Button variant="contained" type="submit" size="large">
//           Complete Sign Up
//         </Button>
//       </Box>
//     </AuthLayout>
//   );
// }
// src/pages/auth/SignupStep3Form.jsx
// import React, { useState } from "react";
// import { Box, Button, Grid, TextField, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AuthLayout from "../../components/AuthLayout";

// export default function SignupStep3Form() {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     username: "",
//     address: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: "" }); // clear field error on change
//   };

//   const validate = () => {
//     const newErrors = {};

//     if (!form.name.trim()) newErrors.name = "Full name is required";
//     if (!form.phone.trim()) newErrors.phone = "Phone number is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Enter a valid 10-digit phone number";

//     if (!form.username.trim()) newErrors.username = "Username is required";
//     else if (/\s/.test(form.username))
//       newErrors.username = "Username cannot contain spaces";

//     if (!form.address.trim()) newErrors.address = "Address is required";

//     if (!form.password.trim()) newErrors.password = "Password is required";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";

//     if (!form.confirmPassword.trim())
//       newErrors.confirmPassword = "Please confirm your password";
//     else if (form.password !== form.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validate()) {
//       console.log("Form submitted:", form);
//       navigate("/dashboard");
//     }
//   };

//   return (
//     <AuthLayout>
//       <Box
//         component="form"
//         onSubmit={handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <Typography variant="h5" textAlign="center" fontWeight={600}>
//           Create your account
//         </Typography>
//         <Typography variant="body2" textAlign="center">
//           Fill in your details to complete registration.
//         </Typography>

//         <Grid container spacing={2}>
//         <Grid item xs={12} sm={6}>
//           <TextField
//             name="name"
//             label="First Name"
//             value={form.name}
//             onChange={handleChange}
//             required
//             fullWidth
//             error={!!errors.name}
//             helperText={errors.name}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             name="name"
//             label="Last Name"
//             value={form.name}
//             onChange={handleChange}
//             required
//             fullWidth
//             error={!!errors.name}
//             helperText={errors.name}
//           />
//         </Grid>
//         </Grid>

//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               name="phone"
//               label="Phone Number"
//               type="tel"
//               value={form.phone}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.phone}
//               helperText={errors.phone}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               name="username"
//               label="Username"
//               value={form.username}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//           </Grid>
//         </Grid>

//         <Grid container spacing={2}>
//         <Grid item xs={12}  sm={12} lg={12} >
//           <TextField
//             name="address"
//             label="Address"
//             value={form.address}
//             onChange={handleChange}
//             required
//             fullWidth
//             error={!!errors.address}
//             helperText={errors.address}
//           />
//         </Grid>
//         </Grid>

//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <TextField
//               name="password"
//               label="Password"
//               type="password"
//               value={form.password}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.password}
//               helperText={errors.password}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               name="confirmPassword"
//               label="Confirm Password"
//               type="password"
//               value={form.confirmPassword}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//             />
//           </Grid>
//         </Grid>

//         <Button variant="contained" type="submit" size="large">
//           Sign Up
//         </Button>
//       </Box>
//     </AuthLayout>
//   );
// }

// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   TextField,
//   Typography,
//   useMediaQuery,
//   // useTheme,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AuthLayout from "../../components/AuthLayout";

// export default function SignupStep3Form() {
//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     phone: "",
//     username: "",
//     address: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();
//   // const theme = useTheme();
//   const isBelow576 = useMediaQuery("(max-width:576px)"); // 👈 detect below 576px

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: "" });
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!form.firstName.trim()) newErrors.firstName = "First name is required";
//     if (!form.lastName.trim()) newErrors.lastName = "Last name is required";
//     if (!form.phone.trim()) newErrors.phone = "Phone number is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Enter a valid 10-digit phone number";
//     if (!form.username.trim()) newErrors.username = "Username is required";
//     else if (/\s/.test(form.username))
//       newErrors.username = "Username cannot contain spaces";
//     if (!form.address.trim()) newErrors.address = "Address is required";
//     if (!form.password.trim()) newErrors.password = "Password is required";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (!form.confirmPassword.trim())
//       newErrors.confirmPassword = "Please confirm your password";
//     else if (form.password !== form.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validate()) {
//       console.log("Form submitted:", form);
//       navigate("/dashboard");
//     }
//   };

//   // 👇 Dynamic column size based on screen
//   const columnSize = isBelow576 ? 12 : 6;

//   return (
//     <AuthLayout>
//       <Box
//         component="form"
//         onSubmit={handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <Typography variant="h5" textAlign="center" fontWeight={600}>
//           Create your account
//         </Typography>
//         <Typography variant="body2" textAlign="center">
//           Fill in your details to complete registration.
//         </Typography>

//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={columnSize}>
//             <TextField
//               name="firstName"
//               label="First Name"
//               value={form.firstName}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.firstName}
//               helperText={errors.firstName}
//             />
//           </Grid>

//           <Grid item xs={12} sm={columnSize}>
//             <TextField
//               name="lastName"
//               label="Last Name"
//               value={form.lastName}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.lastName}
//               helperText={errors.lastName}
//             />
//           </Grid>

//           <Grid item xs={12} sm={columnSize}>
//             <TextField
//               name="phone"
//               label="Phone Number"
//               type="tel"
//               value={form.phone}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.phone}
//               helperText={errors.phone}
//             />
//           </Grid>

//           <Grid item xs={12} sm={columnSize}>
//             <TextField
//               name="username"
//               label="Username"
//               value={form.username}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               name="address"
//               label="Address"
//               value={form.address}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.address}
//               helperText={errors.address}
//             />
//           </Grid>

//           <Grid item xs={12} sm={columnSize}>
//             <TextField
//               name="password"
//               label="Password"
//               type="password"
//               value={form.password}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.password}
//               helperText={errors.password}
//             />
//           </Grid>

//           <Grid item xs={12} sm={columnSize}>
//             <TextField
//               name="confirmPassword"
//               label="Confirm Password"
//               type="password"
//               value={form.confirmPassword}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//             />
//           </Grid>
//         </Grid>

//         <Button variant="contained" type="submit" size="large">
//           Sign Up
//         </Button>
//       </Box>
//     </AuthLayout>
//   );
// }

// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   TextField,
//   Typography,
//   useMediaQuery,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AuthLayout from "../../components/AuthLayout";

// export default function SignupStep3Form() {
//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     phone: "",
//     username: "",
//     address: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();

//   const isBelow576 = useMediaQuery("(max-width:575px)"); // 👈 watch this line

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: "" });
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!form.firstName.trim()) newErrors.firstName = "First name is required";
//     if (!form.lastName.trim()) newErrors.lastName = "Last name is required";
//     if (!form.phone.trim()) newErrors.phone = "Phone number is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Enter a valid 10-digit phone number";
//     if (!form.username.trim()) newErrors.username = "Username is required";
//     else if (/\s/.test(form.username))
//       newErrors.username = "Username cannot contain spaces";
//     if (!form.address.trim()) newErrors.address = "Address is required";
//     if (!form.password.trim()) newErrors.password = "Password is required";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (!form.confirmPassword.trim())
//       newErrors.confirmPassword = "Please confirm your password";
//     else if (form.password !== form.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validate()) {
//       console.log("Form submitted:", form);
//       navigate("/dashboard");
//     }
//   };

//   // 👇 dynamic grid size: 12 below 576, otherwise 6
//   const gridCols = isBelow576 ? 12 : 6;

//   return (
//     <AuthLayout>
//       <Box
//         component="form"
//         onSubmit={handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <Typography variant="h5" textAlign="center" fontWeight={600}>
//           Create your account
//         </Typography>
//         <Typography variant="body2" textAlign="center">
//           Fill in your details to complete registration.
//         </Typography>

//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={gridCols}>
//             <TextField
//               name="firstName"
//               label="First Name"
//               value={form.firstName}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.firstName}
//               helperText={errors.firstName}
//             />
//           </Grid>

//           <Grid item xs={12} sm={gridCols}>
//             <TextField
//               name="lastName"
//               label="Last Name"
//               value={form.lastName}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.lastName}
//               helperText={errors.lastName}
//             />
//           </Grid>

//           <Grid item xs={12} sm={gridCols}>
//             <TextField
//               name="phone"
//               label="Phone Number"
//               type="tel"
//               value={form.phone}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.phone}
//               helperText={errors.phone}
//             />
//           </Grid>

//           <Grid item xs={12} sm={gridCols}>
//             <TextField
//               name="username"
//               label="Username"
//               value={form.username}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               name="address"
//               label="Address"
//               value={form.address}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.address}
//               helperText={errors.address}
//             />
//           </Grid>

//           <Grid item xs={12} sm={gridCols}>
//             <TextField
//               name="password"
//               label="Password"
//               type="password"
//               value={form.password}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.password}
//               helperText={errors.password}
//             />
//           </Grid>

//           <Grid item xs={12} sm={gridCols}>
//             <TextField
//               name="confirmPassword"
//               label="Confirm Password"
//               type="password"
//               value={form.confirmPassword}
//               onChange={handleChange}
//               required
//               fullWidth
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//             />
//           </Grid>
//         </Grid>

//         <Button variant="contained" type="submit" size="large">
//           Sign Up
//         </Button>
//       </Box>
//     </AuthLayout>
//   );
// }


import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "../../components/AuthLayout";
import API_BASE_URL from "../../config/api";

export default function SignupStep3Form() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    username: "",
    address: "",
    monthlySalary: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    // Clear error for this field as user types
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!form.firstName.trim()) newErrors.firstName = "First name is required";
    if (!form.lastName.trim()) newErrors.lastName = "Last name is required";

    if (!form.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(form.phone))
      newErrors.phone = "Enter a valid 10-digit phone number";

    if (!form.username.trim()) newErrors.username = "Username is required";
    else if (/\s/.test(form.username))
      newErrors.username = "Username cannot contain spaces";

    if (!form.address.trim()) newErrors.address = "Address is required";

    if (!form.monthlySalary.trim()) newErrors.monthlySalary = "Monthly salary is required";
    else if (!/^\d+(\.\d{1,2})?$/.test(form.monthlySalary) || parseFloat(form.monthlySalary) <= 0)
      newErrors.monthlySalary = "Enter a valid salary amount";

    if (!form.password.trim()) newErrors.password = "Password is required";
    else if (form.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    if (!form.confirmPassword.trim())
      newErrors.confirmPassword = "Please confirm your password";
    else if (form.password !== form.confirmPassword) {
      toast.error("Passwords do not match");
      return false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    const email = sessionStorage.getItem("signupEmail");
    if (!email) {
      toast.error("Email not found. Please start from the beginning.");
      navigate("/signup");
      return;
    }

    const fullName = `${form.firstName.trim()} ${form.lastName.trim()}`;

    try {
      const response = await fetch(`${API_BASE_URL}/api/users/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fullName,
          email,
          phoneNumber: form.phone,
          username: form.username,
          password: form.password,
          monthlySalary: parseFloat(form.monthlySalary),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Account created successfully!");
        sessionStorage.removeItem("signupEmail");
        navigate("/login");
      } else {
        // Show specific error messages
        if (data.message.includes("Email")) {
          toast.error("Email already exists");
        } else if (data.message.includes("Username")) {
          toast.error("Username already exists");
        } else {
          toast.error(data.message || "Failed to create account");
        }
      }
    } catch (error) {
      console.error("Error creating account:", error);
      toast.error("Failed to create account. Please try again.");
    }
  };

  return (
    <AuthLayout>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <Typography variant="h5" textAlign="center" fontWeight={600}>
          Create your account
        </Typography>
        {/* <Typography variant="body2" textAlign="center">
          Fill in your details to complete registration.
        </Typography> */}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="firstName"
              label="First Name"
              value={form.firstName}
              onChange={handleChange}
              fullWidth
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="lastName"
              label="Last Name"
              value={form.lastName}
              onChange={handleChange}
              fullWidth
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="phone"
              label="Phone Number"
              type="tel"
              value={form.phone}
              onChange={handleChange}
              fullWidth
              error={!!errors.phone}
              helperText={errors.phone}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="username"
              label="Username"
              value={form.username}
              onChange={handleChange}
              fullWidth
              error={!!errors.username}
              helperText={errors.username}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="monthlySalary"
              label="Monthly Salary (₹)"
              type="text"
              value={form.monthlySalary}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numbers and decimal point
                if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
                  handleChange(e);
                }
              }}
              placeholder="Enter monthly salary"
              fullWidth
              error={!!errors.monthlySalary}
              helperText={errors.monthlySalary}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="address"
              label="Address"
              value={form.address}
              onChange={handleChange}
              fullWidth
              error={!!errors.address}
              helperText={errors.address}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="password"
              label="Password"
              type="password"
              value={form.password}
              onChange={handleChange}
              fullWidth
              error={!!errors.password}
              helperText={errors.password}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              value={form.confirmPassword}
              onChange={handleChange}
              fullWidth
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
            />
          </Grid>
        </Grid>

        <Button variant="contained" type="submit" size="large">
          Sign Up
        </Button>
      </Box>
    </AuthLayout>
  );
}










